(function () {
  'use strict';

  // === Aktionscodes — vor Livegang eintragen, z.B. ['GEBURTSTAG20'] ===
  const CODES = ['SXVV6Z5NFTN4'];

  const BOX_PROP = 'Teil der';
  let guardRunning = false;

  // ---- Drawer neu befüllen + data-empty nachziehen ----
  async function reRender() {
    const fresh = await window.cart.get();
    window.renderCart(fresh);
    document.querySelectorAll('[data-empty]').forEach(el => {
      if (fresh.item_count > 0) el.removeAttribute('data-empty');
    });
    if (fresh.item_count === 0) {
      const c = document.querySelector('.quick-cart__container');
      if (c) c.setAttribute('data-empty', '');
    }
  }

  // ---- Box in den Warenkorb ----
  async function addBox(cfg, btn) {
    if (btn) btn.disabled = true;
    try {
      const items = cfg.items.map(i => ({
        id: i.id,
        quantity: i.qty || 1,
        properties: i.gift
          ? { 'Geschenk': 'Geburtstagsaktion', [BOX_PROP]: cfg.box }
          : { [BOX_PROP]: cfg.box }
      }));

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      const icon = document.querySelector('[data-js-cart-icon]');
      const drawer = document.querySelector('[data-quick-cart]');
      const wasOpen = drawer && drawer.classList.contains('visible');
      if (icon && !wasOpen) icon.click();

      setTimeout(reRender, 400);   // IMMER nachziehen, auch nach Icon-Klick

      if (CODES.length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: CODES.join(',') })
        });
        setTimeout(reRender, 900);
      }
    } catch (e) {
      console.error('[HR box]', e);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  // ---- Klick auf den Box-Button ----
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hr-box-atc');
    if (!btn) return;
    e.preventDefault();
    let cfg;
    try { cfg = JSON.parse(btn.dataset.hrBox); }
    catch (err) { console.error('[HR box] JSON kaputt', err); return; }
    if (cfg && cfg.items) addBox(cfg, btn);
  });

  // ---- Guard: Geschenke ohne zugehörige Box entfernen ----
  async function guard() {
    if (guardRunning) return;
    guardRunning = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const paid = {};
      const gifts = [];
      cart.items.forEach(i => {
        const box = i.properties && i.properties[BOX_PROP];
        if (!box) return;
        if (i.properties['Geschenk']) gifts.push(i);
        else paid[box] = true;
      });
      const updates = {};
      gifts.forEach(g => { if (!paid[g.properties[BOX_PROP]]) updates[g.key] = 0; });
      if (!Object.keys(updates).length) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await reRender();
    } catch (e) {
      console.warn('[HR guard]', e);
    } finally {
      guardRunning = false;
    }
  }

  const origFetch = window.fetch;
  window.fetch = function () {
    const a = arguments[0];
    const url = typeof a === 'string' ? a : (a && a.url) || '';
    return origFetch.apply(this, arguments).then(function (res) {
      if (!guardRunning && /\/cart\/(add|change|update)/.test(url)) {
        setTimeout(guard, 150);
      }
      return res;
    });
  };

  document.addEventListener('DOMContentLoaded', guard);
  window.hrGiftGuard = guard;
})();